module.exports = __webpack_public_path__ + "static/media/hamsa.85d88d0d.svg";